<template>
  <div id="XyContent">
    <div id="XyHouseCreate" class="leave-details">
      <div class="details-main">
        <div class="details-state fl" v-if="thisRows.Icon===''" >{{thisRows.FullName ? showName(thisRows.FullName) : ''}}</div>
        <div class="details-state fl" v-else :style="{background:'url('+ thisRows.Icon+')' + '0/cover'}"></div>
        <div class="details-time fl">{{thisRows.FullName ? thisRows.FullName : ''}}</div>
        <div
          class="details-msg fl"
        >{{thisRows.ApplicationStateNameNew ? thisRows.ApplicationStateNameNew : ''}}</div>

        <div class="officeStatus">
          <!--2已通过、3已拒绝、4已收回-->
          <img v-if="thisRows.ApplicationStateNew === 2" class="no-data-img" :src="approvalImg[0]" />
          <img
            v-else-if="thisRows.ApplicationStateNew === 3"
            class="no-data-img"
            :src="approvalImg[1]"
          />
          <img
            v-else-if="thisRows.ApplicationStateNew === 4"
            class="no-data-img"
            :src="approvalImg[2]"
          />
        </div>
      </div>

      <div class="detail-info">
        <div style="margin-top:0;">
          <span class="item-title">请假类型:</span>
          <div class="item-right">{{thisRows.TeacherLeaveTypeName?thisRows.TeacherLeaveTypeName:''}}</div>
        </div>
        <div>
          <span class="item-title">请&nbsp;&nbsp;假&nbsp;&nbsp;人:</span>
          <div class="item-right">{{thisRows.FullName?thisRows.FullName:''}}</div>
        </div>
        <div>
          <span class="item-title">开始时间:</span>
          <div class="item-right">{{thisRows.StartTime?xy.moment(thisRows.StartTime).format('YYYY-MM-DD HH:mm'):''}}</div>
        </div>
        <div>
          <span class="item-title">结束时间:</span>
          <div class="item-right">{{thisRows.EndTime?xy.moment(thisRows.EndTime).format('YYYY-MM-DD HH:mm'):''}}</div>
        </div>
        <div>
          <span class="item-title">请假原因:</span>
          <div
            class="item-right"
          >{{thisRows.ApplicationDescription?thisRows.ApplicationDescription:''}}</div>
        </div>
        <div v-if="thisRows.LeavePictrueList!==undefined&&thisRows.LeavePictrueList.length>1">
          <span class="item-title">请假图片:</span>
          <van-grid :border="false" :column-num="3">
            <van-grid-item v-for="item in thisRows.LeavePictrueList" :key="item">
              <van-image style="width:40px;height:40px;" :src="imgUrl + item" @click="xy.ImagePreview([imgUrl+item])"/>
            </van-grid-item>
          </van-grid>
        </div>
        <div v-if="thisRows.LeavePictrueList!==undefined&&thisRows.LeavePictrueList.length===1">
          <span class="item-title">请假图片:</span>
          <van-grid :border="false" :column-num="3">
            <van-grid-item v-for="item in thisRows.LeavePictrueList" :key="item">
              <van-image style="width:40px;height:40px;" :src="imgUrl + item" @click="xy.ImagePreview([imgUrl+item])"/>
            </van-grid-item>
          </van-grid>
        </div>
        <div v-if="thisRows.ApprovalFlow" style="display: block;">
          <div class="item-title">审批流程:</div>
          <ApprovalFlow :dataList="thisRows.ApprovalFlow" style="position: relative;z-index: 0;margin-top:20px;padding-bottom:0;"></ApprovalFlow>
        </div>
        <div style="display: block;margin-bottom: 20%;" v-if="showAppr && thisRows.JudgeCanOperation">
          <div class="item-title">审批意见:</div>
          <van-field
            v-model="message"
            style="border:1px solid #e6e6e6;margin-top:15px;color:#161616;"
            autosize
            type="textarea"
            maxlength="100"
            show-word-limit
          />
        </div>
      </div>
    </div>

    <SingleBottomBtn
      v-if="showReback && (thisRows.ApplicationStateNew === 0 || thisRows.ApplicationStateNew === 1)"
      @clickBtn="reBack"
    >撤销</SingleBottomBtn>
    <TwoBotttomBtn
      v-if="showAppr && thisRows.JudgeCanOperation"
      left-text="拒绝"
      right-text="同意"
      @cancelClick="saveAppoint(3)"
      @confirmClick="saveAppoint(2)"
    ></TwoBotttomBtn>
  </div>
</template>
<script>
const approvalImg = [
  require("@/assets/attendance/approval-2.png"),
  require("@/assets/attendance/approval-3.png"),
  require("@/assets/attendance/approval-4.png")
];
import SingleBottomBtn from "../../components/SingleBottomBtn";
import ApprovalFlow from "../../../../components/workFlow/ApprovalFlow";
import TwoBotttomBtn from "../../components/TwoBottomBtn";
export default {
  components: {
    ApprovalFlow,
    SingleBottomBtn,
    TwoBotttomBtn
  },
  data() {
    return {
      imgUrl: this.xyMApi + '/att',
      approvalImg,
      colors: "",
      thisRows: {},
      btnStatus: "",
      radio: "",
      message: "",
      // 审批详情时需要
      approvalData: {
        ApprovalFlowNodeID: undefined //当前审批节点的id
      },
      // 展示撤销按钮
      showReback: false,
      // 展示审批按钮
      showAppr: false
    };
  },
  created: function() {
    // 消息
    if (this.$route.query.fromMessage) {
        this.$route.params.TeacherLeaveApplicationID = JSON.parse(this.$store.state.messageInfo).BusinessID
        this.showReback = false;
        this.showAppr = true;
        this.getDetail();
    } else {
      if (this.$route.params.isFrom === "myLeave") {
        this.getDetail();
        this.showReback = true;
        this.showAppr = false;
      } else if (this.$route.params.isFrom === "approval") {
        this.getDetail();
        this.showReback = false;
        this.showAppr = true;
        if(!this.$route.params.type) { 
        this.showReback = false;
        this.showAppr = false;
        }
      } else if (this.$route.params.isFrom === "Record") {
        this.getDetail();
        this.showReback = false;
        this.showAppr = false;
      }
    }
    // if (process.env.NODE_ENV === 'development') {
    //   let a = this.$store.state.messageInfo
    //   console.log(this.$route.query.fromMessage,'是否来自消息','+', a ? JSON.parse(a) : void 0)
    // }
  },
  mounted: function() {
    this.thisRows = this.$store.state.attendance.detailsData;
    this.btnStatus = this.$store.state.attendance.cancelable;
  },
  methods: {
    showName(name) {
      // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
      if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
        return name.length > 3 || name.length === 3 ? name.slice(-2) : name;
      } else if (/^[A-Za-z]+$/g.test(name)) {
        // 纯英文名只展示两个字母
        return name.slice(0, 2);
      } else {
        // 其他
        return name.slice(0, 2);
      }
    },
    // 详情
    async getDetail() {
      this.xy.loading();
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/TeacherLeaveForMobile/GetDetailByID",
        {
          id: this.$route.params.TeacherLeaveApplicationID,
          // approvalFlowID: this.$route.params.ApprovalFlowID
        }
      );
      if (res.success === true) {
        this.xy.unloading();
        this.thisRows = res.data;
        this.format(this.thisRows.ApprovalFlow, "当前审批节点");
      }
    },
    reBack() {
      this.xy.confirm("撤销提示", "你确定要撤销此请假申请吗？", () => {
        this.RevokedMine();
      });
    },
    async RevokedMine() {
      this.xy.loading();
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          "/api/TeacherLeaveForMobile/RevocationLeaveApplication",
        {
          approvalFlowID: this.$route.params.ApprovalFlowID,
          ApprovalFlowNodeID: this.approvalData.ApprovalFlowNodeID,
          UserID: 0, // 固定传0
          Option: this.message,
          Status: 0,
          TeacherApplicationID: this.$route.params.TeacherLeaveApplicationID
        }
      );
      if (res.success) {
        this.xy.unloading();
        this.$router.push(`/home/TeacherLeave/myLeave`);
      }
    },
    async saveAppoint(state) {
      this.xy.loading()
      let params = {
        approvalFlowID: this.thisRows.ApprovalFlowID,
        ApprovalFlowNodeID: this.approvalData.ApprovalFlowNodeID,
        UserID: 0, // 固定传0
        Option: this.message,
        Status: state,
        TeacherApplicationID: this.$route.params.TeacherLeaveApplicationID
      };
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          "/api/TeacherLeaveForMobile/SaveApprovalBranchStatus",
        params
      )      
      this.xy.unloading()
      if (res.success) {
        this.xy.msgSuc("审批完成");
        this.$router.back();
      }
    },
    //当前审批节点获取
    format(data) {
      let _this = this;
      var lastPass_node = 0 // 临时记载：当前遍历中，最后通过审批的节点索引下标；其中，第0个为发起人，即尚未有审批
      data.currentAuditNodeIndex = -1 // 当前待审批节点的下标
      data.map((element, index) => {
        // 缩略预览模式开关
        element.isOverviewMode = true
        // 缩略预览列表(不大于5个)
        element.overviewList = [] // 缩略预览列表(不大于5个)
        element.isFinished = false // 该节点是否审批结束，原因见上
        element.currentAuditNode = false // 该节点是否为当前待审核节点
        // 若该审批项目结束，缩略列表显示最后审批结果的时间与状态
        element.lastComplete_time = undefined
        element.lastComplete_status = undefined
        if (element.IsComplete) {
            // 该节点已经通过了审批，相当于 element.Status === '已通过'
            lastPass_node = index
            element.isFinished = true
        } else if (element.Status === '已拒绝') {
            element.isFinished = true
        } else if (element.Status === '待审批') {
            // 判断是否为当前节点
            if (lastPass_node + 1 === index) {
                // 该节点为当前待审核节点
                element.currentAuditNode = true
                data.currentAuditNodeIndex = index
            }
        }

        var lastTime_member = undefined // 暂存：最近的一次时间点
        element.ApprovalMemberList.forEach(function (memberItem, memberIndex) {
            // 缩略图列表仅显示前4个，其余显示省略号；若共5人，则不显示省略号，直接全部显示
            if (memberIndex < 4 || element.ApprovalMemberList.length === 5) {
                element.overviewList.push(memberItem)
            }
            // 若该节点完成，显示时间、结果
            if (element.isFinished && memberItem.Status !== '待审批') {
                if (element.ApprovalFlowNodeName === '或签') {
                    // 记录唯一一次审批时间
                    element.lastComplete_time = memberItem.ApprovalDate;
                    element.lastComplete_status = memberItem.Status;
                } else if (element.ApprovalFlowNodeName === '会签') {
                    // 记录最后一次会签时间
                    if (lastTime_member === undefined) {
                        // 记载首次审批的时间
                        lastTime_member = memberItem.ApprovalDate
                    } else {
                        var lastTime = new Date(lastTime_member)
                        var thisTime = new Date(memberItem.ApprovalDate)
                        if (thisTime > lastTime) {
                            element.lastComplete_time = memberItem.ApprovalDate;
                            element.lastComplete_status = memberItem.Status;
                        }
                    }
                }
            }
            if (!element.isFinished) {
                // 获取当前需审批的节点：第一个非完成节点
                if (
                    _this.approvalData.ApprovalFlowNodeID === undefined &&
                    element.ApprovalFlowNodeName !== '发起人'
                ) {
                    _this.approvalData.ApprovalFlowNodeID = element.ApprovalFlowNodeID;
                }
            }
        })
        // 抄送列表，大致逻辑同上
        element.isOverviewMode_CC = true
        element.overviewList_CC = []
        element.ApprovalCCMemberList.forEach(function (CCItem, CCIndex) {
            // 缩略图列表仅显示前4个，其余显示省略号；若共5人，则不显示省略号，直接全部显示
            if (CCIndex < 4 || element.ApprovalCCMemberList.length === 5) {
                element.overviewList_CC.push(CCItem)
            }
        })
      });
    }
  }
};
</script>
<style lang="less">
#XyContent {
  width: 100%;
}
.leave-details-head {
  line-height: 80px;
  text-align: center;
}
.leave-details {
  background: #fff;
  font-size: 14px;
  overflow: hidden;
}
.leave-details > .details-main {
  display: block;
  height: 180px;
  overflow: hidden;
}
.leave-details > .details-main .officeStatus {
  position: absolute;
  right: 0px;
  top: 120px;
  width: 218px;
  height: 220px;
}
.leave-details > .details-main .officeStatus img {
  width: 80%;
  height: 80%;
}
.leave-details > .details-main > .details-state {
  width: 92px;
  height: 92px;
  background: #2980fe;
  border-radius: 50%;
  text-align: center;
  line-height: 92px;
  margin-top: 40px;
  margin-left: 70px;
  color: #fff;
  font-size: 30px;
  background-size: 92px 92px;
}
.leave-details > .details-main > .details-time {
  line-height: 120px;
  padding-left: 30px;
  font-size: 28px;
  font-weight: bold;
}
.leave-details > .details-main > .details-msg {
  line-height: 220px;
  font-size: 28px;
  position: absolute;
  left: 26%;
}
.leave-details > .details-list {
  padding: 0 30px;
}
.leave-details > .details-list .yd-flexbox-vertical .yd-flexbox-item {
  display: block;
  margin: 20px 0;
}

.detail-info {
  font-size: 28px;
  padding: 0 20px 0 20px;
}
.detail-info > div {
  display: flex;
  // width: 100%;
  margin: 30px;
  height: auto;
  span {
    color: #606060;
  }
}
.detail-info .item-title {
  width: 5em;
  flex-shrink: 0;
  color: #999;
}
.detail-info .item-right {
  width: calc(100% - 5em);
  color: #161616;
}
.bottom-btn {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  background: #fff;
  box-shadow: 0 2px 21px 0 rgba(186, 186, 186, 0.44);
  display: flex;
  .van-button {
    display: block;
    width: 22%;
    height: 80px;
    line-height: 80px;
    color: #fff;
    font-weight: 700;
    font-size: 30px;
    font-weight: 400;
    margin: 10px auto 15px;
    text-align: center;
    border-radius: 45px;
    background: #4196ff !important;
    float: left;
    justify-content: center;
    align-items: center;
  }
}
</style>
